'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/SpeakerHigh.es.js";
const o = a.forwardRef((r, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...r, weights: e }));
o.displayName = "SpeakerHighIcon";
const c = o;
export {
  c as SpeakerHigh,
  o as SpeakerHighIcon
};
